import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination]);

$(() => {
    const swiper = new Swiper('.swiper', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 10,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1.08,
                spaceBetween: 20,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
                spaceBetween: 60,
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
            // when window width is >= 1350px
            1350: {
                slidesPerView: 2,
                spaceBetween: 52,
            },
        },
    });
});

$(() => {
    const swiper = new Swiper('.swiper-case-studies', {
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        spaceBetween: 0,
    });

    // On click event for bullet navigation
    $('.swiper-case-studies .swiper-nav-bullet').on('click', function (e) {
        e.preventDefault(e);
        const index = $(this).data('slide');

        swiper.slideToLoop(index);

        $('.swiper-case-studies .swiper-nav-bullet').removeClass('active');
        $(this).addClass('active');
    });
});
